import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Timer from './Timer';
import styles from './TimerBar.module.css';

const TimerBar = (props) => {
  const { endTime } = props;
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });
  const isTablet = useMediaQuery({
    query: '(min-width: 768px) and (max-width: 1023px)',
  });

  let viewSize = 'small';
  if (isTablet) {
    viewSize = 'medium';
  } else if (isDesktop) {
    viewSize = 'large';
  }

  return (
    <div className={`${styles.timerBar} ${styles[viewSize]}`}>
      <div className={styles.content}>
        <i className="fal fa-smile" />
        <p>Congrats! Now that you’ve purchased your FFF subscription, your box will process in:</p>
        {!!endTime && <Timer expDate={endTime} />}
      </div>
    </div>
  );
};

TimerBar.propTypes = {
  endTime: PropTypes.instanceOf(Date).isRequired,
};

export default TimerBar;
